var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.456 19h-2.912a.284.284 0 0 1-.209-.085.284.284 0 0 1-.085-.209V13.75H5.294a.284.284 0 0 1-.209-.085.284.284 0 0 1-.085-.209v-2.912c0-.082.028-.152.085-.209a.284.284 0 0 1 .209-.085h4.956V5.294c0-.082.028-.152.085-.209A.284.284 0 0 1 10.544 5h2.912c.082 0 .152.028.209.085a.284.284 0 0 1 .085.209v4.956h4.956c.082 0 .152.028.209.085a.284.284 0 0 1 .085.209v2.912a.284.284 0 0 1-.085.209.284.284 0 0 1-.209.085H13.75v4.956a.284.284 0 0 1-.085.209.284.284 0 0 1-.209.085z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.79da791935457d248cb96448f3c60d73.svg";
export { ForwardRef as ReactComponent };